import React from 'react';
import { IconBase, IconProps } from './IconBase';
import { createIcon } from './createIcon';

const FLAG_PATH =
  'M2 3H21.1384C21.6385 3 21.6385 3.22386 21.6385 3.5C21.6385 3.58701 21.6157 3.67252 21.5725 3.74807L18 10L21.5725 16.2519C21.7095 16.4917 21.6262 16.7971 21.3865 16.9341C21.3109 16.9773 21.2254 17 21.1384 17H4V22H2V3Z';

// Create the icon utilities - only use toDataUrl from createIcon
const { toDataUrl } = createIcon(FLAG_PATH);

// Export the data URL generator
export const toIconFlagDataUrl = toDataUrl;

// Export the IconBase version
export const IconFlag: React.FunctionComponent<IconProps> = ({ ...props }) => (
  <IconBase viewBox="0 0 24 24" {...props}>
    <path d={FLAG_PATH} fill="currentColor" />
  </IconBase>
);
